<div class="main-content-wrappper">
  <div class="container-wrapper">
    <mat-tab-group [selectedIndex]="selected" (selectedTabChange)="clearPagination($event)">
      <mat-tab *ngFor="let item of mainBaseArray" label={{item.name}}>
        <ng-template matTabContent>
          <div class="faq-section">
            <div class="accordian-wrapper" >
              
              <ul *ngIf="item.child.length > 0">
                <li *ngFor="let childItem of item.child | paginate: { itemsPerPage: 10, currentPage: p }; 
                  index as i" (click)="goToSubCategory(childItem.id, childItem.permalink);">
                  <h2 class="label" *ngIf="item.child.length > 0">{{childItem.name}}</h2>
                  <span class="icon-right-chevron"></span>
                </li>
              </ul>

              <ul *ngIf="item.child.length == 0">
                <li *ngFor="let item of faqArray | paginate: { itemsPerPage: 10, currentPage: pageNumber }; index as i"  (click)="goTosubCategoryAnswers(item.id, item.permalink, item.title)">
                  <h2 class="label">{{item.title}}</h2>
                  <span class="icon-right-chevron"></span>
                </li>
              </ul>

            </div>
          </div>
          <pagination-controls *ngIf="item.child.length > 0" (pageChange)="p = $event" class="float-right"></pagination-controls>
          <pagination-controls *ngIf="item.child.length == 0" (pageChange)="pageNumber = $event" class="float-right"></pagination-controls>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <!-- <app-lets-chat></app-lets-chat> -->
  </div>
</div>